var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreen = function SvgScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "screen_svg__st0",
    d: "M22 1H2C.9 1 0 2 0 3.3v13.4C0 18 .9 19 2 19h6.2l-1.5 3.1c-.1.4.1.9.5.9h9.7c.4 0 .6-.5.4-.9L15.8 19H22c1.1 0 2-1 2-2.3V3.3C24 2 23.1 1 22 1zm0 15.8H2V3.3h20v13.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "screen_svg__st0",
    d: "m13.1 13.9 5.7-4.6-5.7-4.5v2s-6.6 1.7-8 8.5c2.9-3.6 8-3.4 8-3.4v2z"
  })));
};
export default SvgScreen;